module.exports = __webpack_public_path__ + "img/deep3.2c4a00f3.png";